import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { ACCOUNT } = ANALYTICS_CATEGORIES;
const { HOVER } = SNOWPLOW_EVENTS;

export const triggerSellerMessagingSaveDefaultBodyTooltipHoveredEvent = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: ACCOUNT.SELLER_MESSAGING,
		name: 'dlr_seller_messaging_save_default_body_tooltip_hovered',
		schemaName: HOVER.SCHEMA,
		version: HOVER.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
